<template>
  <div class= "commonPhrasesList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-input placeholder="请输入常用语内容" v-model="commonName"></el-input>
				</el-form-item>
        <el-button type="primary" @click="getData">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-button type="primary" slot="header" @click="back()">返回上一级</el-button>
      <el-button type="primary" slot="header" @click="add()">添加常用语</el-button>
      <el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange" :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109">
        <el-table-column type="selection" width="55" v-if="maintainTypeManagecheckbox"></el-table-column>
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
        <el-table-column prop="commonName" label='常用语内容'></el-table-column>
        <el-table-column label='所属一级分类'>
          <template slot-scope="scope">
            {{ getMaintainTypeName(scope.row.maintaintypeId) }}
          </template>
        </el-table-column>
        <el-table-column prop="operate" :label="$t('lang.lab_operation')" fixed="right" :width="require('@/config/enum').opr_width3">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="deleteOne(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
      </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
    <el-dialog :title=title :visible.sync="isPopupPage" :close-on-click-modal="false"
      center
      top="130px"
      width="600px"
      @closed="handleDialogClosed">
      <el-form :model="form" :rules="rules" ref="form" :label-width="require('@/config/enum').c_ws6" :label-suffix="require('@/config/enum').c_colon">
        <el-form-item label="常用语内容" prop="commonName" class="input-width">
          <input style="display: none"/>
          <el-input v-model="form.commonName" placeholder="请输入常用语内容" maxlength="50"></el-input>
        </el-form-item>
        <!-- 一级报事分类 -->
        <el-form-item label="一级分类" prop="maintaintypeId">
          <el-select class="input-width" v-model="form.maintaintypeId" filterable
            collapse-tags :placeholder="$t('lang.trialFirstLevelTip')">
            <el-option v-for="(item,index) in firstLevellist" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm()">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" @click="save('form')" :disabled="isDisabled">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      pageCount: 0, // 总页数
      pageNo: 1, // 页数
      pageSize: 10, // 每页显示数量
      isDisabled: true, // 保存的可点击
      isPopupPage: false, // 弹框的显示控制
      isAdd: false, // 标识新增(true)或编辑(false)
      editId: '', // 正在编辑的ID
      title: '', // 弹窗标题
      
      tableData: [], // 列表数据
      multipleSelection: [], // 多选框
      maintainTypeManagecheckbox: require('@/config/enum').maintainTypeManagecheckbox, // 是否隐藏复选框
      firstLevellist: [], // 一级分类list
      maintaintypeId: '',
      commonName: '',
      form: {
        maintaintypeId: '',
        commonName: ''
      }, // 弹窗列表数据
      rules: {
        maintaintypeId: [{ required: true, message: '请选择一级分类', trigger: 'change' }],
        commonName: [{ required: true, message: '请输入常用语内容', trigger: 'blur' }],
      }
    }
  },
  computed: {
      ...mapGetters(['gardenId'])
    },
  created() {
    this.maintaintypeId = this.$route.query.maintaintypeId
    this.getData()
    this.maintainTypes()
  },
  watch: {
    form: {
      handler(newVal, oldVal) {
        // form数据变化时 会调用此方法
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          // 没变
          this.isDisabled = true
        } else {
          // 变了
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选框
    handleSelectionChange(val) {
        this.multipleSelection = val
    },
    // 一级报事分类list
    maintainTypes() {
        this.$get(
          `/maintainTypes?type=1&pageNo=1&pageSize=999&parentId=${this.gardenId}`
        ).then(
          res => {
            if (res && res.errCode === 0) {
                this.firstLevellist = res.list
                console.log(this.firstLevellist)
            }
          },
          error => {
            this.$message.error(error)
          }
        )
    },
    // 获取表格数据
    getData() {
      let loading = this.$loading()
      this.$get(`/maintaintypeCommon?maintaintypeId=${this.maintaintypeId}&commonName=${this.commonName}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )      
    },
    // 返回
    back() {
      this.$router.go(-1)
    },
    // 添加
    add() {
      this.title = '新增常用语'
      this.isPopupPage = true
      this.isAdd = true
    },
    // 编辑
    edit(rowData) {
      this.title = '编辑常用语'
      this.editId = rowData.id
      this.form.commonName = rowData.commonName
      this.form.maintaintypeId = rowData.maintaintypeId
      this.isPopupPage = true
      this.isAdd = false
      this.saveData = JSON.stringify(this.form)
    },
    // 删除
    deleteOne(id) {
      this.$confirm(this.$i18n.t('lang.lab_isdelete'), this.$i18n.t('lang.lab_prompt'), {
        confirmButtonText: this.$i18n.t('lang.btn_confirm'),
        cancelButtonText: this.$i18n.t('lang.btn_cancel'),
        type: 'warning'
      }).then(() => {
          this.$delete(`/maintaintypeCommon/` + id).then(
            res => {
              if (res && res.errCode === 0) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_del_success')
                })
                this.commit()
              }
            },
            error => {
              this.$message.error(error)
            }
          )
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can')
          })
        })
    },
    // 更新
    commit() {
      this.pageNo = 1
      this.getData()
    },
    // 保存
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.isAdd) {
            let params = {
              maintaintypeId: this.form.maintaintypeId,
              commonName: this.form.commonName,
            }
            let loading = this.$loading()
            this.$post(`/maintaintypeCommon`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.isPopupPage = false
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            let loading = this.$loading()
            let params = {
              maintaintypeId: this.form.maintaintypeId,
              commonName: this.form.commonName,
            }
            this.$patch(`/maintaintypeCommon/${this.editId}`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.isPopupPage = false
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
                this.isPopupPage = false
              }
            )
          } 
        }
      })
    },
    // 清空
    resetForm() {
      this.$refs.form.clearValidate()
      this.form.maintaintypeId = ''
      this.form.commonName = ''
    },
    // 监听关闭dialog
    handleDialogClosed() {
      this.resetForm()
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.getData()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getData()
    },
    // 在methods中添加以下方法
    getMaintainTypeName(id) {
      const item = this.firstLevellist.find(item => item.id === id)
      return item ? item.name : ''
    },
  }
}
</script>

<style lang= 'scss'>
.commonPhrasesList{
  .input-width{
    width: 100%;
  }
  .el-select, .el-input { /* 明确设置选择框和输入框的宽度 */
    width: 100%;
  }
}
</style>